
export const STATIC_DATA = {
  SELECTED_PROGRAM: "selected_program",
  SELECTED_LEAD: "selected_lead",
  LEAD_ENTRY: "lead_entry",
  PARTICIPANT_INFO: "participant_info",
  SERVICE_DETAILS: "service_details",
  COMMUNICATION_PREFERENCES: "comm_preferences",
  CONTACT_DETAILS: "contact_details",
  ASSOCIATIONS: "associations",
  SERVICE_CREDENTIALS: "service_credentials",
  CONSUMER_RATES: "consumer_rates",
  FORMS: "forms",
  SIGNATURES: "signatures",
  SIGNATURE_EMPLOYER_CUSTOM_NOTE: 'If the employer is unable to sign (because they are a minor or have a disability that prevents them from signing), their representative should type into the signature box: the participant’s name, the word “by," and then the representative’s name, relationship to the participant, and social security number.',
  HORIZONTAL_FIRST_MENU: "horizontal_first_menu",
  SHARED_PARTICIPANT_LEADS_DATA: "shared_participant_leads_data",
  SHARED_PROVIDER_LEADS_DATA: "shared_provider_leads_data",
  SHARED_PARTICIPANT_ENROLLMENT_DATA: "shared_participant_enrollment_data",
  SHARED_PROVIDER_ENROLLMENT_DATA: "shared_provider_enrollment_data",
  SHARED_ENROLLMENT_DATA: "shared_enrollment_data",
  SHARED_REFERRAL_DATA: "shared_referral_data",
  SHARED_PAYROLL_PROCESSING_DATA: "shared_payroll_processing_data",
  SHARED_GLOBAL_CONSUMER_SEARCH_DATA: "shared_global_consumer_search_data",
  SHARED_PROCESS_CODE_DATA: "shared_process_code_data",
  SHARED_SERVICE_CODE_DATA: "shared_service_code_data",
  SHARED_PARTICIPANT_PROVIDER_RATES_DATA: "shared_participant_provider_rates_data",
  SHARED_INDIVIDUAL_PROVIDER_DATA: "shared_individual_provider_data",
  SHARED_FILE_TRAGE_DATA: "shared_file_triage_data",
  SHARED_FILE_UPLOAD_NOTIFICATION_DATA: "shared_file_upload_notification_data",
  SHARED_PROVIDER_TIMESHEET: "shared_provider_timesheet_data",
  SHARED_PROVIDER_TIMEOFF_DATA: "shared_provider_timeoff_data",
  SHARED_BATCHES_DATA: "shared_batches_data",
  SHARED_BILLING_FILES_DATA: "shared_billing_files_data",
  SHARED_CLAIMS_DATA: "shared_claims_data",
  SHARED_PMPM_CLAIMS_DATA: "shared_pmpm_claims_data",
  SHARED_RECON_FILES_DATA: "shared_recon_files_data",
  SHARED_PAYMENT_RECON_DATA: "shared_payment_recon_data",
  LEAD_PROGRAM: "Pre_Ref",
  CASDP_PROGRAM_CODE: "CASDP",
  // California-only address validation (CASDP). State dropdown holds the
  // 2-letter code, but the full name is accepted defensively.
  CALIFORNIA_STATE_VALUES: ["CA", "CALIFORNIA"],
  CALIFORNIA_ONLY_MESSAGE:
    "Only California addresses are allowed. Please enter California address to continue.",
  PROSPECTIVE_PARTICIPANTS_DATA: "lead_details_prospective_participants_data",
  LEAD_DETAILS_CONTACT_LIST_HEADERS: "lead_details_contact_list_headers",
  LEAD_PROF_LICENCES: "prof_licences",
  LEAD_SERVICES_RENDERED: "service_rendered",
  APPROVED: "Approved",
  PROVIDER: "provider",
  REFERRAL: "referral",
  PARTICIPANT: "participant",
  PARTICIPANT_ENROLLMENT: "participantEnrollment",
  PROVIDER_ENROLLMENT: "providerEnrollment",
  PARTICIPANT_ENROLLMENT_LIST: "participantEnrollmentList",
  PROVIDER_ENROLLMENT_LIST: "providerEnrollmentList",
  ASSOCIATION_DISASSOCIATED_STATUS: "Disassociated",
  ASSOCIATION_RESTORE_STATUS: "Restore",
  ASSOCIATION_REHIRE_STATUS: "Rehire",
  RESTORE_REHIRE_THRESHOLD_DAYS: 180,
  PARTICIPANT_RESTORE_REENROLL_THRESHOLD_DAYS: 365,
  ASSOCIATION_EMPLOYER: "employer",
  ASSOCIATION_VENDOR: "vendor",
  ASSOCIATION_AUTHORIZED_REPRESENTATIVE: "authorized_representative",
  ASSOCIATION_AUTHORIZED_REPRESENTATIVE_TYPE: "Authorized Representative",
  ASSOCIATION_EMPLOYER_TYPE: "Employer",
  ASSOCIATION_PARTICIPANT_TYPE: "Participant",
  ASSOCIATION_INDEPENDENT_PROVIDER: "independent_provider",
  ASSOCIATION_INDEPENDENT_CONTRACTOR: "independent_contractor",
  ASSOCIATION_INDEPENDENT_FACILITATOR: "independent_facilitator",
  ASSOCIATION_LEGAL_GUARDIAN: "legal_guardian",
  ASSOCIATION_POWER_OF_ATTORNEY: "poa",
  ASSOCIATION_CONSERVATOR: "conservator",
  ASSOCIATION_PAPERWORK_COMPLETE_STATUS: "Paperwork Complete",
  DOCUMENT_PARTICIPANT_ENROLLMENT_TYPE: "participantenrlmnt",
  DOCUMENT_PROVIDER_ENROLLMENT_TYPE: "providerenrlmnt",
  IN_PPL_REVIEW: "In PPL Review",
  ENROLLMENT_ACTIVE: "Registration Active",
  URL_FIRST_SEGMENT: "first_segment",
  SHARED_CASE_MANAGER_DATA: "shared_case_manager_data",
  STATUS_FOR_AUTH: ['P', 'GP', 'AC'],
  PROCESSING_STATUS_FOR_AUTH: ['TP'],
  SHARED_FILE_PAYLIST_DATA: "shared_file_paylist_data",
  SHARED_FILE_DETAIL_PAYLIST_DATA: "shared_file_paylist_detail_data",
}


export const DETAIL_PAGE_BACKBUTTON = {
  [STATIC_DATA.PROVIDER]: "Back to Provider Interest",
  [STATIC_DATA.PARTICIPANT]: "Back to Consumer Interest",
  [STATIC_DATA.REFERRAL]: "Back to Referrals",
  [STATIC_DATA.PARTICIPANT_ENROLLMENT]: "Back to Consumer Registration",
  [STATIC_DATA.PROVIDER_ENROLLMENT]: "Back to Association Registration"
}

export const ASSOCIATIONS_ADD_BUTTON = {
  [STATIC_DATA.ASSOCIATION_EMPLOYER]: "Add Employer",
  [STATIC_DATA.ASSOCIATION_AUTHORIZED_REPRESENTATIVE]: "Add Authorized Representative",
  [STATIC_DATA.ASSOCIATION_INDEPENDENT_PROVIDER]: "Add Independent Provider",
  [STATIC_DATA.ASSOCIATION_VENDOR]: "Add Vendor",
  [STATIC_DATA.ASSOCIATION_INDEPENDENT_CONTRACTOR]: "Add Independent Contractor",
  [STATIC_DATA.ASSOCIATION_INDEPENDENT_FACILITATOR]: "Add Independent Facilitator",
  [STATIC_DATA.ASSOCIATION_LEGAL_GUARDIAN]: "Add Legal Guardian",
  [STATIC_DATA.ASSOCIATION_POWER_OF_ATTORNEY]: "Add POA",
  [STATIC_DATA.ASSOCIATION_CONSERVATOR]: "Add Conservator"
}

export const PROVIDER_TYPES: Record<string, string> = {
  AR: 'Authorization Representative',
  EMP: 'Employer',
  IC: 'Independent Contractor',
  IF: 'Independent Facilitator',
  IR: 'Independent Provider',
  LG: 'Legal Guardian',
  POA: 'POA',
  VE: 'Vendor',
  IP: 'Independent Provider',
  CNV: 'Conservator'
}

/** Display label per identifier type code, for fields the backend names differently than the UI does. */
export const DUPLICATE_IDENTIFIER_FIELD_LABELS: Record<string, string> = {
  CIN: 'UCI ID',
};

export const ASSOCIATION_TYPE_UI_MAPPINGS = {
  [STATIC_DATA.ASSOCIATION_EMPLOYER]: "EMP",
  [STATIC_DATA.ASSOCIATION_AUTHORIZED_REPRESENTATIVE]: "AR",
  [STATIC_DATA.ASSOCIATION_INDEPENDENT_PROVIDER]: "IR",
  [STATIC_DATA.ASSOCIATION_VENDOR]: "VE",
  [STATIC_DATA.ASSOCIATION_INDEPENDENT_CONTRACTOR]: "IC",
  [STATIC_DATA.ASSOCIATION_INDEPENDENT_FACILITATOR]: "IF",
  [STATIC_DATA.ASSOCIATION_LEGAL_GUARDIAN]: "LG",
  [STATIC_DATA.ASSOCIATION_POWER_OF_ATTORNEY]: "POA",
  [STATIC_DATA.ASSOCIATION_CONSERVATOR]: "CNV"
}

export const PROVIDER_TYPE_MAPPING = {
  INDEPENDENT_PROVIDER: 'IP',
  INDEPENDENT_CONTRACTOR: 'IC',
  INDEPENDENT_PROVIDER_CONTRACTOR: 'IP_IC',
  INDEPENDENT_VENDOR: 'Vendor'
}

export const STATIC_DATA_BASE_PATH = "/assets/data/programs"

export const STATIC_JSON_DATA_PATH = {
  EXTERNAL_PARTICIPANT_MENU: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/external/{flow}/horizontal_menu.json`,
  LEAD_DETAILS_MENU: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/horizontal_menu.json`,
  LEAD_LIST_PAGE_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/contact-list-headers.json`,
  LEAD_DETAILS_SECTION_DATA: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/sections.json`,
  LEAD_DETAILS_PROSPECTIVE_PARTICIPANTS_DATA: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/prospective-participants.json`,
  PROVIDER_LEAD_DETAILS_IP_SECTION_DATA: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/sections_IP.json`,
  PROVIDER_LEAD_DETAILS_IC_SECTION_DATA: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/sections_IC.json`,
  PROVIDER_LEAD_DETAILS_IP_IC_SECTION_DATA: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/sections_IP_IC.json`,
  PROVIDER_LEAD_DETAILS_Vendor_SECTION_DATA: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/sections_Vendor.json`,
  REFERRAL_FORM: `${STATIC_DATA_BASE_PATH}/{code}/sections.json`,
  LEAD_DETAILS_PROVIDER_ENROLLMENT_SECTION_DATA: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/basicInfo/{comp}_sections.json`,
  LEAD_DETAILS_CONTACT_LIST_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/contact-list-headers.json`,
  LEAD_DETAILS_VIEWER_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/participant_viewer.json`,
  LEAD_DETAILS_ENROLLMENT_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/enrollment_status.json`,
  LEAD_DETAILS_DOCUMENT_LIST_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/document-file-headers.json`,
  FILE_UPLOAD_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/list_pages/uploaded_list_headers.json`,
  PARTICIPANT_ASSOCIATIONS_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/list_pages/list_participant_associations.json`,
  LEAD_DETAILS_PROVIDERS_SECTION_DATA: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/participantEnrollment/associations/{comp}.json`,
  ADDITIONAL_ATTRIBUTES: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/participantEnrollment/additional-attributes.json`,
  ASSOCIATIONS_DETAILS_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/participantEnrollment/associations_details_headers.json`,
  ALL_ASSOCIATIONS_DETAILS_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/participantEnrollment/all_associations_details_headers.json`,
  ENROLLMENT_SUMMARY_ITEMS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/summary-items.json`,
  PROVIDER_ASSOCIATIONS_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/providerEnrollment/associations_details_headers.json`,
  PROVIDER_ASSOCIATIONS_STATUS_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/providerEnrollment/enrollment_status.json`,
  AUTHORIZATIONS_CONSUMER_LIST_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/forms/payroll/{flow}/consumer-list.json`,
  AUTHORIZATIONS_LIST_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/forms/payroll/{flow}/authorizations-list-headers.json`,
  AUTHORIZATIONS_PARTICIPANT_DETAILS_LIST_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/lead_details/{flow}/authorizations-list-headers.json`,
  SERVICE_CODE_RATES_LIST_HEADERS: `${STATIC_DATA_BASE_PATH}/{code}/forms/payroll/{flow}/rate-list.json`,
  AUTHORIZATIONS_SECTION_DATA: `${STATIC_DATA_BASE_PATH}/{code}/forms/payroll/{flow}/form.json`,
  CREATE_CONSUMER_ASSOCIATION: `${STATIC_DATA_BASE_PATH}/{code}/forms/participantEnrollment/associations/{flow}.json`
};


export const APP_REGEX = {
  PREFERRED_TIME: /(\d{1,2}:\d{2} (?:AM|PM)) - (\d{1,2}:\d{2} (?:AM|PM))/,
  PREFERRED_DAYS: /\[(.*?)\]/
}

export const RADIO_YES_NO_OPTIONS = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' }
];

export const RADIO_BOOLEAN_YES_NO_OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];

export const RADIO_DISTANCE_OPTIONS = [
  { label: 'Office Distance - I want to travel to facilitator', value: 'Office' },
  { label: 'In-Home Visit Distance - I want facilitator to travel to me', value: 'InHome' },
];

export const FLOW_MAPPINGS: Record<string, string> = {
  'participants': 'Participant Interest',
  'providers': 'Provider Interest',
  'referral': 'Participant Referral',
  'newEnrollment': 'Registration',
  'participantEnrollment': 'Participant Enrollment',
  'provider': 'Independent Provider',
  'authRepresentative': 'Authorization Representative',
  'employer': 'Employer',
  'vendor': 'Vendor',
  'contractor': 'Independent Contractor',
  'poa': 'POA',
  'legalGuardian': 'Legal Guardian',
  'conservator': 'Conservator',
  'independentFacilitator': 'Independent Facilitator'
};

export const ENROLLMENT_TYPE: Record<string, string> = {
  'authorized_representative': 'authRepresentative',
  'conservator': 'conservator',
  'employer': 'employer',
  'independent_provider': 'provider',
  'independent_contractor': 'contractor',
  'independent_facilitator': 'independentFacilitator',
  'vendorName': 'contractor',
  'legal_guardian': 'legalGuardian',
  'poa': 'poa',
  'vendor': 'vendor'
}

export const ENROLLMENT_TYPE_MAPPINGS: Record<string, string> = {
  'newProvider': 'provider',
  'newAuthRep': 'authRepresentative',
  'newEmployer': 'employer',
  'newVendor': 'vendor',
  'newContractor': 'contractor',
  'newIndependentFacilitator': 'independentFacilitator',
  'newPOA': 'poa',
  'newLegalGuardian': 'legalGuardian',
  'newConservator': 'conservator'
};

export const ENROLLMENT_TYPE_BACKEND_MAPPINGS: Record<string, string> = {
  'IR': 'provider',
  'PA': 'provider',
  'AR': 'authRepresentative',
  'DR': 'authRepresentative',
  'EMP': 'employer',
  'VE': 'vendor',
  'IC': 'contractor',
  'IF': 'independentFacilitator',
  'LG': 'legalGuardian',
  'POA': 'poa',
  'IC_IP': 'contractor_provider',
  'CNV': 'conservator'
};

export const ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS: Record<string, string> = {
  'provider': 'IR',
  'authRepresentative': 'AR',
  'conservator': 'CNV',
  'employer': 'EMP',
  'vendor': 'VE',
  'contractor': 'IC',
  'independentFacilitator': 'IF',
  'legalGuardian': 'LG',
  'poa': 'POA',
  'legalguardian': 'LG',
  'authrep': 'AR',
  'contractor_provider': 'IC_IP'
};


export const ENROLLMENT_TITLE_MAPPINGS: Record<string, string> = {
  'provider': 'Independent Provider',
  'authRepresentative': 'Authorization Representative',
  'conservator': 'Conservator',
  'employer': 'Employer',
  'vendor': 'Vendor',
  'contractor': 'Independent Contractor',
  'independentFacilitator': 'Independent Facilitator',
  'poa': 'POA',
  "legalGuardian": 'Legal Guardian'
};

export const DAYS_OF_WEEK = ['Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun'];

/**
 * Provider Classification checklist form. Read through getPDFFormData and written
 * through the provider forms save endpoint, so the ids below identify the form and
 * the keys match the fieldIds the API returns in Form_Fields.
 */
export const VE_PROVIDER_CLASSIFICATION_FORM = {
  formMasterId: 163,
  checklistItemId: 341,
  checklistItemDetailId: 469,
  fields: {
    servesAll: 'People with and without I/DD',
    vendored: 'Vendored with Regional Center',
    followsProgramDesign: 'Follows Regional Center Program Design',
    vendorNumber: 'Regional Center Vendor Number',
    initialFilingDate: 'Initial Filing Date',
    vendorClassification: 'Vendor Classification',
  },
};

export const IC_PROVIDER_CLASSIFICATION_FORM = {
  formMasterId: 163,
  checklistItemId: 343,
  checklistItemDetailId: 470,
  fields: {
    servesAll: 'People with and without I/DD',
    vendored: 'Vendored with Regional Center',
    followsProgramDesign: 'Follows Regional Center Program Design',
    vendorNumber: 'Regional Center Vendor Number',
    initialFilingDate: 'Initial Filing Date',
    vendorClassification: 'Vendor Classification',
  },
};

export const IF_PROVIDER_CLASSIFICATION_FORM = {
  formMasterId: 163,
  checklistItemId: 353,
  checklistItemDetailId: 486,
  fields: {
    servesAll: 'People with and without I/DD',
    vendored: 'Vendored with Regional Center',
    followsProgramDesign: 'Follows Regional Center Program Design',
    vendorNumber: 'Regional Center Vendor Number',
    initialFilingDate: 'Initial Filing Date',
    vendorClassification: 'Vendor Classification',
  },
};

/**
 * The classification form for a provider type. The three forms differ only by which checklist
 * item they are stored against — same form, same fields — so call sites key off this instead of
 * repeating a three-way choice that then has to be kept in step everywhere.
 */
export const PROVIDER_CLASSIFICATION_FORMS: Record<string, typeof IC_PROVIDER_CLASSIFICATION_FORM> = {
  VE: VE_PROVIDER_CLASSIFICATION_FORM,
  IC: IC_PROVIDER_CLASSIFICATION_FORM,
  IF: IF_PROVIDER_CLASSIFICATION_FORM,
};

/** Falls back to the IC form, which is what every call site defaulted to before. */
export function getProviderClassificationForm(providerType: string): typeof IC_PROVIDER_CLASSIFICATION_FORM {
  return PROVIDER_CLASSIFICATION_FORMS[providerType] ?? IC_PROVIDER_CLASSIFICATION_FORM;
}

/** Provider Types derived from the Provider Classification question flow. */
export const PROVIDER_CLASSIFICATION_TYPES = {
  localBusiness: 'Local Business/Community Resource',
  sdpProvider: 'SDP Provider',
  regionalCenterVendor: 'Regional Center Vendor',
};

/**
 * Frequency options offered when capturing a service detail under a provider auth
 * allocation. Values are the codes the API accepts; labels are display only.
 */
export const AUTH_SERVICE_FREQUENCIES = [
  { label: 'Hourly', value: 'HOURLY' },
  { label: 'Daily', value: 'DAILY' },
  { label: 'Weekly', value: 'WEEKLY' },
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Semi-Monthly', value: 'SEMI_MONTHLY' },
  { label: 'Annually', value: 'ANNUALLY' },
  { label: 'One-Time', value: 'ONE_TIME' },
  { label: 'Open', value: 'OPEN' },
];

export const PARTICIPANT_LIMITED_ACCESS_PAGES = ['enrollmentInformation']

export const SHORT_TO_FULL_DAY: Record<string, string> = {
  Mon: 'Monday',
  Tues: 'Tuesday',
  Wed: 'Wednesday',
  Thurs: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday'
};

export const MIN_AGE_DOB: any = {
  'participants': 0,
  'providers': 18,
  'referral': 0,
  'participantEnrollment': 0,
  'providerEnrollment': 18,
  'provider': 18,
  'authRepresentative': 18,
  'poa': 18,
  'legalGuardian': 18,
  'conservator': 18
}

export const ADDITIONAL_ATTRIBUTE_MAP = {
  recieveGoodsAndServices: 110
};

export const formMasterIdMap: Record<string, number> = {
  IR: 95,
  IC: 97,
  EMP: 96,
  VE: 94,
  AR: 117,
  LG: 118,
  CNV: 119,
  POA: 120,
  IF: 121
};

export type ProviderCode = 'AR' | 'EMP' | 'IR' | 'IC' | 'VE' | 'IF' | 'POA' | 'CNV' | 'LG';

// checklistItemId that identifies the On-Duty Meal Break form within an Independent Provider
// (IR/IP) association checklist.
export const ON_DUTY_MEAL_BREAK_CHECKLIST_ITEM_ID = 336;

// checklistItemId that identifies the HCBS form within a provider-participant association checklist,
// keyed by provider type. Only Vendor (VE) and Independent Contractor (IC) associations have one.
export const HCBS_CHECKLIST_ITEM_IDS: Record<string, number> = {
  VE: 147,
  IC: 250
};

/**
 * Employment task managers that identify one specific person. When changing the Employer of
 * Record, the outgoing EOR's task manager cannot be selected again if it is one of these -
 * a participant has only one self, one father and one mother. Matched against the start of the
 * Employment_Tasks lookup name, so "Self (Participant)" is covered and "Grandchild" is not.
 */
export const SINGLE_INSTANCE_EMPLOYMENT_TASKS: string[] = ['self', 'father', 'mother'];

/**
 * IRS Form W-9 form name — matches DynamicForm.name for formMasterId 107/123/124 (all three
 * program-provider-type W-9 entries in provider-enrollment-forms.json). Used to gate the
 * W-9-specific handling in ProviderEnrollmentFormsComponent: the Legal Name/DBA demographics
 * sync, the Taxpayer ID confirmation note, and the SSN/EIN unmask-on-save fallback.
 */
export const W9_FORM_NAME = 'IRS Form W-9 Form';

/**
 * Field ids on the W-9 dynamic form config (provider-enrollment-forms.json). Shared between
 * DynamicFormRendererComponent (validation/save-payload handling) and
 * ProviderEnrollmentFormsComponent (prefill overrides from getAssociationsDetails, the
 * unmask-on-save fallback) so the two stay in sync if the JSON's field ids ever change.
 */
export const W9_FIELD_IDS = {
  NAME: 'Name',
  BUSINESS_NAME: 'Business name',
  MAILING_ADDRESS: 'Mailing address',
  TAX_ID_TYPE: 'Taxpayer Identification Number Type',
  // Masked (display-only) SSN/EIN value and its computed single-box display field.
  SSN_VALUE: 'SSN Value',
  EIN_VALUE: 'EIN Value',
  SSN_DISPLAY: 'Social Security Number',
  EIN_DISPLAY: 'Employer Identification Number',
  // Real (unmasked) segments matched by businessName against the actual signed PDF's Form_Fields.
  SSN_SEGMENT_1: 'Social security number 1',
  SSN_SEGMENT_2: 'Social security number 2',
  SSN_SEGMENT_3: 'Social security number 3',
  EIN_SEGMENT_1: 'Employer identification number 1',
  EIN_SEGMENT_2: 'Employer identification number 2',
} as const;

/** Taxpayer Identification Number Type radio values on the W-9 form. */
export const TAX_ID_TYPE = {
  SSN: 'SSN',
  EIN: 'EIN',
} as const;

export type TaxIdType = typeof TAX_ID_TYPE[keyof typeof TAX_ID_TYPE];

/**
 * Context fields for the unmask-identifier API call made when saving the W-9 with a Taxpayer ID
 * type whose real PDF segments are still empty (see
 * ProviderEnrollmentFormsComponent.ensureSelectedTaxIdSegmentsPopulated). Mirrors the payload
 * shape LeadDetailIdentifiersComponent.getUnMaskAPIPayload already uses for this same API.
 */
export const W9_UNMASK_IDENTIFIER_CONTEXT = {
  SOURCE: 'PPL@Home',
  USER_TYPE: 'provider',
  USER_CATEGORY: 'enrollment',
} as const;
